import {
  Play,
  Camera,
  AtSign,
  Music,
  FileText,
  Image,
} from "lucide-react";

export const toolIconMap = {
  "youtube-downloader": Play,
  "instagram-downloader": Camera,
  "twitter-downloader": AtSign,
  "video-to-mp3": Music,
  "doc-to-pdf": FileText,
  "image-to-pdf": Image,
};

export function ToolIcon({ slug, className = "w-6 h-6", strokeWidth = 1.75 }) {
  const Icon = toolIconMap[slug];
  if (!Icon) return null;
  return <Icon className={className} strokeWidth={strokeWidth} aria-hidden />;
}
